var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconArrowUp = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7 11.3004L12.7 4.30039C12.6 4.20039 12.5 4.10039 12.4 4.10039C12.2 4.00039 11.9 4.00039 11.6 4.10039C11.5 4.20039 11.4 4.20039 11.3 4.30039L4.3 11.3004C3.9 11.7004 3.9 12.3004 4.3 12.7004C4.7 13.1004 5.3 13.1004 5.7 12.7004L11 7.40039V19.0004C11 19.6004 11.4 20.0004 12 20.0004C12.6 20.0004 13 19.6004 13 19.0004V7.40039L18.3 12.7004C18.5 12.9004 18.8 13.0004 19 13.0004C19.2 13.0004 19.5 12.9004 19.7 12.7004C20.1 12.3004 20.1 11.7004 19.7 11.3004Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconArrowUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconArrowUp.625df8fabfcc3188615b4528efda9344.svg";